import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  Output,
  EventEmitter,
  Input,
  Renderer2,
} from '@angular/core';
import { Router } from '@angular/router';
import { AccountDto } from '../../../../data/models/account-dto';
import { LineDetailsDto } from '../../../../data/models/line-details-dto';
import { LinesPaginationWithCount } from '../../../../data/models/lines-pagination-with-count';
import { AccountService } from '../../../../services/account.service';
import { AppService } from '../../../../services/app.service';
import { AuthService } from '../../../../services/auth.service';
import { StatusClassService } from '../../../../services/status-class.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-menu-sidebar',
  templateUrl: './menu-sidebar.component.html',
  styleUrls: ['./menu-sidebar.component.scss']
})
export class MenuSidebarComponent implements OnInit, AfterViewInit {
  public sidebarMenuOpened = true;

  @ViewChild('mainSidebar', { static: true }) mainSidebar;
  @Output() mainSidebarHeight: EventEmitter<any> = new EventEmitter<any>();
  @Output() toggleMenuSidebar: EventEmitter<any> = new EventEmitter<any>();


  //@Input() account: AccountDto;
  fullMenu: any[];
  linesList: any[];
  pageSize: number = 10;
  accountUcid: string;
  loader: boolean = false;
  @Input() account: AccountDto=new AccountDto();

  constructor(private appService: AppService, /*private location: Location,*/ private accountService: AccountService,
    private router: Router, private authService: AuthService, private statusClass: StatusClassService, private renderer: Renderer2
    , private breakpointObserver: BreakpointObserver) {
    //this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //  return false;
    //};
  }
  displayManage: boolean = false;
  user: string;
  isAdmin: boolean = false;
  lineTotalRecords: number;
  filter: string = '';
  paginatorFirstIndex: number = 0;
  isMobile: boolean = false;

  ngOnInit() {
    this.breakpointObserver.observe([
      Breakpoints.HandsetPortrait,
      '(max-width: 500px)'
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });
    if (sessionStorage.getItem(authenticationEnum.username))
      this.user = sessionStorage.getItem(authenticationEnum.username);

    let token = sessionStorage.getItem('token');
    let accId = parseInt(this.authService.getTokenClaims(token).AccountId);

    this.loadLines({ rows: this.pageSize, first: 0 });
    

  }

  ngAfterViewInit() {
    this.mainSidebarHeight.emit(this.mainSidebar.nativeElement.offsetHeight);
  }
  checkAccess(page): boolean {
    return this.appService.isHasAccessTo(page);
  }

  loadLines(event) {
    if (event.filters?.name) {
      if (event.filters.name.value.length < 3)
        return;
    }

    this.loader = true;
    this.pageSize = event.rows;

    let obj = {
      skipped:  event.first,
      size: event.rows
    }

    this.accountService.getLinesDetailsOfAccountPagination(obj).subscribe((res: LinesPaginationWithCount) => {
      if (res) {
        this.lineTotalRecords = res.count;

        res.lines.forEach(l => {
          l.fakeName = l.name.slice(0, l.name.indexOf('.')) + "." + l.quoteID  ;
          if (l.pairNum) l.fakeName += (".Pair" + l.pairNum);
          l.fakeName += " (" + l.popName + ")";
            
        });
        this.linesList = res.lines;
        this.fullMenu = res.lines.map((item) => {
          return {
            name: item.fakeName, link: "linedetails/" + item.id, lineStatus: item.lineStatus, isMonitored: item.isMonitored
          }
        });
        this.loader = false;

       
      }
      else {
        this.linesList = [];
        this.lineTotalRecords = 0;
        this.loader = false;
      }
    }, (error) => {
      this.loader = false;
    }
    )

  }



  reset() {
    //Set first index to 0
    this.paginatorFirstIndex = 0;
    this.loadLines({ rows: this.pageSize, first: this.paginatorFirstIndex });
  }

  previous() {
    // Set first index of page to firstIndex - rows
    if ((this.paginatorFirstIndex - this.pageSize) < 0) return;
    this.paginatorFirstIndex = this.paginatorFirstIndex - this.pageSize;
    this.loadLines({ rows: this.pageSize, first: this.paginatorFirstIndex });
  }

  next() {
    // Set first index of page to firstIndex + rows
    if ((this.paginatorFirstIndex + this.pageSize) > this.lineTotalRecords) return;

    this.paginatorFirstIndex = this.paginatorFirstIndex + this.pageSize;
    this.loadLines({ rows: this.pageSize, first: this.paginatorFirstIndex });
  }

  isFirst(): boolean {
    return this.fullMenu ?
      this.paginatorFirstIndex === 0 : true;
  }

  isLast(): boolean {
    return this.fullMenu ?
      (this.paginatorFirstIndex + this.pageSize) > this.lineTotalRecords : true;
  }

  getViewClass(status) {
    return this.statusClass.getViewClass(status);
  }

  getStatusName(item) {
    return this.statusClass.getStatus(item.lineStatus);
  }

  clipstring(inputstring) {
    return inputstring.length > 20 ? inputstring.substring(0, 20) + "..." : inputstring;
  }
  showHideSideMenu() {
    this.toggleMenuSidebar.emit();
  }
}
export class authenticationEnum {
  public static username: string = 'userName';
  public static accountName: string = 'accountName';
  public static ucid: string = 'ucid';
  public static userId: string = 'userId';
  public static token: string = 'token';
  public static refreshToken: string = 'refreshToken';
  public static access: string = 'access';
  public static loggedIn: string = 'loggedIn';
  public static hasAccess: string = 'hasAccess';
  public static loginTime: string = 'loginTime';
  public static true: string = 'true';
  public static logoImage: string = 'logoImage';

}

export class authorizationEnum {
  public static showReachabilityDetails: string = 'showReachabilityDetails';
   
}
